import CampaignMappingFieldResourceModel from '../../generated/types/model/resource/CampaignMappingFieldResourceModel';

export default class CampaignMappingFieldResourceViewModel extends CampaignMappingFieldResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
